import React, {useEffect, useState} from 'react';
import {Form, Select} from 'antd';
import GenericDialog from '@common/GenericDialog';
import axios from '@common/axios';

const EditTimeZoneDialog = ({open, onClose}) => {
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [timeZoneOptions, setTimeZoneOptions] = useState([]);

    useEffect(() => {
        if (open) {
            setIsFetching(true);
            setErrorMessage(null);
            axios.get('/web/ui/accountSettings/timezone')
                .then(res => {
                    setTimeZoneOptions(res.data.timeZones);
                    form.setFieldsValue({timeZoneId: res.data.timeZoneId});
                })
                .catch(() => setErrorMessage('Failed to load time zones.'))
                .finally(() => setIsFetching(false));
        } else {
            form.resetFields();
            setErrorMessage(null);
        }
    }, [open, form]);

    const handleSubmit = async () => {
        let values;
        try {
            values = await form.validateFields();
        } catch {
            return;
        }

        setIsLoading(true);
        setErrorMessage(null);
        try {
            await axios.post('/web/ui/accountSettings/timezone', {timeZoneId: values.timeZoneId});
            onClose();
        } catch (e) {
            setErrorMessage(e?.response?.data?.message || 'Failed to update time zone.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <GenericDialog
            title="Time Zone"
            open={open}
            onClose={onClose}
            isLoading={isLoading || isFetching}
            errorMessage={errorMessage}
            dialogWidth={480}
            buttons={[
                {name: 'Cancel', extraProps: {type: 'text'}},
                {name: 'Save', callback: handleSubmit, extraProps: {type: 'primary'}},
            ]}
        >
            <Form form={form} layout="vertical" className="ch-form">
                <Form.Item
                    name="timeZoneId"
                    label="User Time Zone"
                    rules={[{required: true, message: 'Please select a time zone'}]}
                >
                    <Select
                        options={timeZoneOptions}
                        placeholder="Select a time zone"
                        showSearch
                        filterOption={(input, option) =>
                            option.label.toLowerCase().includes(input.toLowerCase())
                        }
                    />
                </Form.Item>
            </Form>
        </GenericDialog>
    );
};

export default EditTimeZoneDialog;
